module.exports = __webpack_public_path__ + "static/media/RA4.bc6475f4.gif";